import { FC } from 'react';
import { Stack, Theme } from '@mui/material';
import { createUseStyles } from 'react-jss';
import Icon from '@/components/icon';
import Tooltip from '@/components/tooltip';
import Text from '@/components/text';
import classNames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  featureCheckmark: {
    width: 22,
    height: 22,
    borderRadius: theme.shape.borderRadius,
    '&.enabled': {
      backgroundColor: '#12d4061f',
    },
    '&.partial': {
      backgroundColor: theme.palette.chip.infoBackground,
    },
  },
}));

interface Props {
  enabled?: boolean;
  partial?: boolean;
  label: string;
}

const FeatureCheckmark: FC<Props> = ({ enabled = true, partial = false, label }) => {
  const styles = useStyles();
  const compClass = classNames(styles.featureCheckmark, { enabled: enabled && !partial, partial });

  const tooltipStatus = partial
    ? 'Partially supported'
    : enabled
      ? 'Fully Supported'
      : 'Not supported';

  let IconEl = <Text color="grey">-</Text>;

  if (enabled) {
    IconEl = <Icon name="check" size="x-small" color="success" />;
  } else if (partial) {
    IconEl = <Icon name="check" size="x-small" color="info" />;
  }

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" width="100%">
      <Tooltip title={`${label}: ${tooltipStatus}`}>
        <Stack alignItems="center" justifyContent="center" className={compClass}>
          {IconEl}
        </Stack>
      </Tooltip>
    </Stack>
  );
};

export default FeatureCheckmark;
